import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { SelectedLanguageAtom } from '@projtech-package/react-components/lib';
import { APP_CONFIGS } from '@config/config';
import { setPreference } from '@store/prefrences';
import axios from 'axios';
import { useHandleCache } from '@hooks/useHandleCache';
import { queryClient } from '@utils';

interface ILangDropdownProps {
	onSubmit?: () => Promise<void>;
}

export function LangDropdownComponent({ onSubmit }: ILangDropdownProps) {
	const { t, i18n } = useTranslation();
	const [lang, setLang] = useAtom(SelectedLanguageAtom);
	let selectedLang =
		APP_CONFIGS.LANGUAGES.find((f) => f.code === lang) || APP_CONFIGS.LANGUAGES.find((f) => f.code === 'ar');
	const { setCache } = useHandleCache();

	return (
		// <div className="ml-5 hover:bg-base-100">
		<ul
			className="relative flex flex-wrap px-1.5 py-1.5 list-none rounded-md bg-[#D8E5FE]"
			data-tabs="tabs"
			role="list"
		>
			{[
				{
					name: t('AR'),
					id: 'ar',
				},
				{
					name: t('DE'),
					id: 'de',
				},
			].map((l) => (
				<li key={l.id} className="z-30 flex-auto text-center">
					<a
						className={
							'z-30 flex items-center justify-center w-full py-2 text-sm mb-0 transition-all ease-in-out border-0 rounded-md cursor-pointer  p-5 ' +
							(selectedLang?.code === l.id ? 'bg-primary text-white' : 'bg-inherit text-slate-600')
						}
						data-tab-target=""
						role="tab"
						aria-selected="true"
						onClick={async () => {
							await onSubmit?.();
							await axios.get('local/' + l.id);
							await setPreference({
								key: 'lang',
								value: l.id,
							});
							i18n.changeLanguage(l.id);
							setLang(l.id);
							setCache('lang', l.id);
							window.document.getElementById('lang-dropdown')?.removeAttribute('open');
							axios.defaults.headers.common['x-locale'] = l.id;
							queryClient.clear();
						}}
					>
						{l.name}
					</a>
				</li>
			))}
			{/* <li>
				<details id="lang-dropdown">
					<summary>
						{' '}
						<div className="flex items-center px-2 gap-2">
							{selectedLang?.svg()}
							<span>{t(selectedLang?.name || '')}</span>
						</div>
					</summary>
					<ul className="bg-base-100 rounded-t-none p-2 z-50">
						{APP_CONFIGS.LANGUAGES?.map((item) => (
							<div
								className="flex items-center p-2  gap-2 cursor-pointer"
								key={item.code}
								onClick={async () => {
									await onSubmit?.();
									await setPreference({
										key: 'lang',
										value: item.code,
									});
									i18n.changeLanguage(item.code);
									setLang(item.code);
									window.document.getElementById('lang-dropdown')?.removeAttribute('open');
								}}
							>
								{item.svg()}
								<span>{t(item?.name)}</span>
							</div>
						))}
					</ul>
				</details>
			</li> */}
		</ul>
	);

	{
		/* <div className="dropdown dropdown-end">
                <div tabIndex={0} role="button">
                    <div className="flex items-center px-2 gap-2">
                        {selectedLang.svg()}
                        <span>{t(selectedLang.value)}</span>
                    </div>
                </div>
                <ul
                ref={ref}
                tabIndex={0}
                className="menu dropdown-content bg-base-100 px-5 z-50">
                {
                            langData.map((item) => (
                                <div className="flex items-center p-2  gap-2" key={item.key} onClick={() => {
                                    i18n.changeLanguage(item.key);
                                    setLang(item.key);
                                }}>
                                    {item.svg()}
                                    <span>{t(item.value)}</span>
                                </div>
                            ))
                        }
                </ul>
            </div> */
	}
	// </div>
}
